import { useState, useEffect } from 'react';
import { GoogleMap, Marker, DirectionsRenderer } from '@react-google-maps/api';

export default function MapPreview({ fromCoord, toCoord, showRoute, selectedRouteIndex, onRoutesFound }) {
  const [directionsResult, setDirectionsResult] = useState(null);
  const [routeError, setRouteError] = useState(false);

  const center = fromCoord || toCoord || { latitude: 28.6139, longitude: 77.2090 };
  const mapCenter = { lat: center.latitude, lng: center.longitude };

  useEffect(() => {
    if (!showRoute || !fromCoord || !toCoord || !window.google) {
      setDirectionsResult(null);
      return;
    }

    const directionsService = new window.google.maps.DirectionsService();
    directionsService.route(
      {
        origin: { lat: fromCoord.latitude, lng: fromCoord.longitude },
        destination: { lat: toCoord.latitude, lng: toCoord.longitude },
        travelMode: window.google.maps.TravelMode.DRIVING,
        provideRouteAlternatives: true,
      },
      (result, status) => {
        if (status === 'OK') {
          setDirectionsResult(result);
          setRouteError(false);
          if (onRoutesFound) {
            const routeSummaries = result.routes.map((route, idx) => ({
              index: idx,
              distanceKm: route.legs[0].distance.value / 1000,
              durationMin: route.legs[0].duration.value / 60,
              summary: route.summary || ('Route ' + (idx + 1)),
              coords: route.overview_path.map(p => ({ latitude: p.lat(), longitude: p.lng() })),
            }));
            onRoutesFound(routeSummaries);
          }
        } else {
          setRouteError(true);
          setDirectionsResult(null);
        }
      }
    );
  }, [showRoute, fromCoord, toCoord]);

  return (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height: '100%', borderRadius: 16 }}
      center={mapCenter}
      zoom={fromCoord && toCoord ? 8 : 12}
      options={{ disableDefaultUI: true, zoomControl: true }}
    >
      {!directionsResult && fromCoord && (
        <Marker position={{ lat: fromCoord.latitude, lng: fromCoord.longitude }} label={{ text: 'A', color: '#ffffff', fontWeight: 'bold' }} />
      )}
      {!directionsResult && toCoord && (
        <Marker position={{ lat: toCoord.latitude, lng: toCoord.longitude }} label={{ text: 'B', color: '#ffffff', fontWeight: 'bold' }} />
      )}
      {directionsResult && (
        <DirectionsRenderer
          directions={directionsResult}
          routeIndex={selectedRouteIndex || 0}
          options={{
            polylineOptions: { strokeColor: '#3a8fd0', strokeWeight: 5 },
            suppressMarkers: false,
          }}
        />
      )}
    </GoogleMap>
  );
}